import owd from 'owd/owd';
import _ from 'underscore';

export default class Header extends owd.Component {
	init() {
		this.height = this.$element.outerHeight();
		this.trigger = 0;
		this.prevScroll = 0;
		this.bind();
	}

	countHeight() {
		this.height = this.$element.outerHeight();
		this.trigger = .5 * this.height;
	}

	bind() {
		this.on('load ajaxload resize', this.dom.$window, () => {
			this.countHeight();
		})
		
		this.on('scroll ajaxload', this.dom.$window, _.throttle(() => {
			let currScroll = this.dom.$window[0].pageYOffset;

			if (currScroll > this.trigger) {
				this.$element.addClass('is-moved');

				if (currScroll >= this.prevScroll) {
					this.$element.addClass('is-hidden');
				} else {
					this.$element.removeClass('is-hidden');
				}
			} else {
				this.$element.removeClass('is-moved');
				this.$element.removeClass('is-hidden');
			}

			this.prevScroll = currScroll;
		}, 100))
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('header', {
	component: Header
});
